import { geoJsonFilePath, dataFilePath, hhsDataFilePath } from '../config';

const dataURLs = {
  data: `${process.env.PUBLIC_URL}/${dataFilePath}`,
  hhs: `${process.env.PUBLIC_URL}/${hhsDataFilePath}`,
  geo: `${process.env.PUBLIC_URL}/${geoJsonFilePath}`,
};

export const getCouncilData = () =>
  fetch(dataURLs.hhs).then(response => response.json());

export const getEduData = () =>
  fetch(dataURLs.data).then(response => response.json());

export const getQldRegionGeo = () =>
  fetch(dataURLs.geo).then(response => response.json());



// WEBPACK FOOTER //
// ./src/api/index.js